<script>
import CTA from '@phoenix/mixins/components/common/CTA';
import { PhxsgButton } from '@sg/src/View/Components/Atoms/Button';

export default {
  components: { PhxsgButton },

  mixins: [CTA],

  props: {
    variant: {
      type: String,
      default: 'primary',
    },
    full: {
      type: Boolean,
      default: false,
    },
    expandTarget: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<template>
  <phxsg-button
    use="a"
    :href="link"
    v-bind="attributes"
    :variant="variant"
    :full="full"
    :expand-target="expandTarget"
    :icon="$icon && { end: { id: icon, bidirectional: iconBidirectional } }"
  >
    <span v-html="getText" />
  </phxsg-button>
</template>
